import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Blob} from 'activestorage';

interface IState {
  previewSrc: string | undefined;
  imageBlob: Blob | null;
}

const initialState: IState = {
  previewSrc: undefined,
  imageBlob: null,
};

const imageUploaderSlice = createSlice({
  name: 'imageUploader',
  initialState,
  reducers: {
    setPreviewSrcAC: (state, action: PayloadAction<IState['previewSrc']>) => {
      state.previewSrc = action.payload;
    },
    setImageBlobAC: (state, action: PayloadAction<IState['imageBlob']>) => {
      state.imageBlob = action.payload;
    },
  },
});

export default imageUploaderSlice;

export const {setPreviewSrcAC, setImageBlobAC} = imageUploaderSlice.actions;
